import { Box, Paper, Typography } from "@mui/material";
import images from '../../../../../data/images.json';

export default function LocationPage(){
    return(
    <Box
        sx={{
            position: 'relative',
            height: '100vh',
            overflow: 'hidden',
            '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url("${images.location.background.src}")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            filter: 'blur(3px)',
            zIndex: 0,
            },
            zIndex: 1,
        }}
        display="flex"
        flexDirection="column"
        alignItems="center"
    >
        <Box 
            sx={{ 
                position: 'relative', 
                zIndex: 1,
                width:650,
                height:500,
                m:5
            }}
        >
            <Paper 

            >
                <Typography sx={{p:1}}>Leof. G. Gregou 45, Porto Rafti 190 03</Typography>
                <iframe 
                    title="Fyki Fyki Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3148.573224666102!2d24.0119954!3d37.8936622!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a18f02bc06fa9b%3A0x243cb18dd0f81c26!2sFyki-Fyki!5e0!3m2!1sen!2sgr!4v1749186694335!5m2!1sen!2sgr" 
                    width="600" 
                    height="450" 
                    style={{border:0}}
                    allowfullscreen="" 
                    loading="lazy" 
                    referrerpolicy="no-referrer-when-downgrade">
                </iframe>
            </Paper>
        </Box> 
        
    </Box>
    );
}